<template>
  <div>
    <div class="game-definition-grid-page">
      <div class='game-definition-grid-description'>
        <div class="grid-description-item">
          <h1>Choose a Game to Play</h1>
        </div>
        <div class="grid-description-item">
          <span>Don't see a game you want?</span><b-button @click="showModal = true">Add a new game</b-button>
          <DefineGame @game-definition-added="handleNewGameDefinition" v-if="showModal" @cancel="showModal = false" @close="showModal = false"/>
        </div>
    </div>
      <div class="game-definition-grid-container">
        <div class="game-definition-grid">
          <GameDefinition v-for="(gameDefinition, index) in gameDefinitions" :gameDefinition="gameDefinition" :key="index" />
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import Vue from 'vue'

import gamedefinitions from "../../api/game-definitions";
import DefineGame from "./DefineGame";
import GameDefinition from './GameDefinition'
import { BListGroup } from 'bootstrap-vue'

Vue.component('b-list-group', BListGroup)

export default {
  name: "new-game",
  components: {
    DefineGame,
    GameDefinition
  },
  data() {
    return {
      gameDefinitions: [],
      showModal: false,
    };
  },
  methods: {
    retrieveGameDefinitions() {
    /* eslint-disable no-console */
      console.log('getting game definitions')
      gamedefinitions.getGameDefinitions(response => {
          this.gameDefinitions = response; // JSON are parsed automatically.
          console.log(response);
        }, e => {
          console.log(e);
        });
    }
    /* eslint-enable no-console */
  },
  mounted() {
    this.retrieveGameDefinitions();
  }
};
</script>
 
<style>

.btn-success {
  background-color: rgb(13, 83, 13);
}

.game-definition-grid-page {
  justify-content: center;
}

.grid-description-item {
  justify-content: center;
  text-align: center;
}

.grid-description-item > h1 {
  justify-content: center;
  text-align: center;
}


.grid-description-item > span {
  justify-content: center;
  margin: 5px;
  /* border: 1px solid #f00; */
  text-align: center;
  padding-right: 4px;
}

.game-definition-grid-container {
  display: flex;
  justify-content: center;
}

.game-definition-grid {
  width: 1400px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  padding: 5px;
}


.submitform {
  max-width: 300px;
  margin: auto;
}


</style>